"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var mention_1 = require("@draft-js-plugins/mention");
var react_1 = require("react");
var Entry_1 = __importDefault(require("./Entry"));
var MentionSuggestionsComponent_1 = __importDefault(require("./MentionSuggestionsComponent"));
var Mentions = function (_a) {
    var MentionSuggestions = _a.MentionSuggestions, users = _a.users, services = _a.services;
    var _b = __read((0, react_1.useState)(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = __read((0, react_1.useState)(__spreadArray(__spreadArray([], __read(users), false), __read(services), false)), 2), suggestions = _c[0], setSuggestions = _c[1];
    var onOpenChange = (0, react_1.useCallback)(function (open) { return setIsOpen(open); }, []);
    var onSearchChange = (0, react_1.useCallback)(function (_a) {
        var value = _a.value;
        return setSuggestions(__spreadArray(__spreadArray([], __read((0, mention_1.defaultSuggestionsFilter)(value, __spreadArray([], __read(users), false)).slice(0, 3)), false), __read((0, mention_1.defaultSuggestionsFilter)(value, __spreadArray([], __read(services), false)).slice(0, 3)), false));
    }, []);
    return ((0, jsx_runtime_1.jsx)(MentionSuggestions, { open: isOpen, onOpenChange: onOpenChange, suggestions: suggestions, onSearchChange: onSearchChange, popoverContainer: MentionSuggestionsComponent_1.default, entryComponent: Entry_1.default }));
};
exports.default = Mentions;
